import React, { useState } from 'react';
import { Box, Button, FormControl, Textarea, Select, Option, Typography, Breadcrumbs, Link } from '@mui/joy';
import { KeyboardArrowRight } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { PERMISSIONS } from '../../main/context/AuthContext';
import { usePermissions } from '../../main/hooks/usePermissions';

export default function SendMessageScreen() {
  const { t } = useTranslation('ui');
  const [message, setMessage] = useState('');
  const [selectedCustomers] = useState('');
  const { hasPermission } = usePermissions();

  // Route-level gating lives in ROUTE_PERMISSIONS; this is defense-in-depth
  // for the (future) API call in handleSubmit.
  const canSendWhatsApp = hasPermission(PERMISSIONS.WHATSAPP_SEND_SHIPMENT_NOTIFICATION);

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!canSendWhatsApp) return;
    console.log('Message:', message);
    console.log('Selected Customers:', selectedCustomers);
    // Add your logic to send the message here
  }

  if (!canSendWhatsApp) {
    return (
      <Box sx={{ display: 'flex' }}>
        <Box width={"100%"} m={6}>
          <Typography level="h1" color="danger">
            {t('whatsapp.accessDenied')}
          </Typography>
          <Typography level="body1">
            {t('whatsapp.noPermissionSend')}
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Box width={"100%"} m={6}>
        <Box>
          <Breadcrumbs separator={<KeyboardArrowRight />} aria-label="breadcrumbs">
            {[t('whatsapp.notifications'), t('whatsapp.broadcast')].map((item) => (
              <Link key={item} color="neutral" href="/shipments">
                {item}
              </Link>
            ))}
          </Breadcrumbs>
          <Typography textAlign={"start"} level="h1">{t('whatsapp.broadcastTitle')}</Typography>
          <Typography textAlign={"start"} level="p1">{t('whatsapp.forAllCustomers')}</Typography>
        </Box>

        <form onSubmit={handleSubmit}>
          {/* Message Body Field */}
          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <Textarea
              placeholder={t('whatsapp.messagePlaceholder')}
              minRows={6}
              maxRows={12}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </FormControl>

          {/* Customer Selection Dropdown */}
          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <Select
              label={t('whatsapp.selectCustomers')}
              value={selectedCustomers}
            // onChange={(e) => setSelectedCustomers(e.target.value)}
            >
              {/* Add customer options dynamically or statically */}
              <Option value="customer1">Customer 1</Option>
              <Option value="customer2">Customer 2</Option>
              <Option value="customer3">Customer 3</Option>
            </Select>
          </FormControl>

          {/* Submit Button */}
          <Button type="submit">
            {t('whatsapp.sendMessage')}
          </Button>
        </form>
      </Box>
    </Box>
  );
}
